const selectors = {
  screenReaderElement: '.sr-only',
  starsContainer: '.yotpo-stars, .yotpo-review-stars, .rating-stars-container',
};

const ariaHideStars = () => {
  const starIcons = document.querySelectorAll('.yotpo-icon.rating-star');

  Array.from(starIcons).forEach((icon) => {
    icon.setAttribute('aria-hidden', 'true');
  });
};

const provideMaxStarValue = () => {
  const starsContainer = document.querySelectorAll(selectors.starsContainer);

  Array.from(starsContainer).forEach((element) => {
    const screenReaderElement = element.querySelector(selectors.screenReaderElement);
    const starRatingText = screenReaderElement.innerText;

    const regex = /^[0-9]+\.?[0-9] star rating$/i;
    if (regex.test(starRatingText)) {
      const finalText = starRatingText.replace(/star rating/, 'out of 5 star rating');

      screenReaderElement.innerText = finalText;
    }
  });
};

const observer = new MutationObserver(() => {
  ariaHideStars();
  provideMaxStarValue();
});

window.addEventListener('load', () => {
  ariaHideStars();
  provideMaxStarValue();

  const mainYotpoWidget = document.querySelector('.yotpo-main-widget');

  if (!mainYotpoWidget) return;

  observer.observe(mainYotpoWidget, {
    subtree: true,
    childList: true,
  });
});
